import { Avatar, Paper, Stack } from '@mui/material';
import { Title } from './Title';
import { PersonWithBoxes } from 'Images';
import { AllDocuments } from './AllDocuments';
import { AdvancedFilter } from './AdvancedFilter';
import { Search } from './Search';
import { ToggleFilter } from './ToggleFilter';
import { DocumentAmount } from './DocumentAmount';
import { useIsDesktop } from 'Hooks';
import { useContext } from 'react';
import { DocumentsContext } from 'Context/DocumentsContext';
import { NoDocumentsFound } from './NoDocumentsFound';
import { MobileFilter } from './MobileFilter';

export const Lobby = () => {
  const { filter, documents } = useContext(DocumentsContext);
  const isDesktop = useIsDesktop();

  if (
    !filter.advancedFilterActive &&
    documents.previousYearsResults.length === 0 &&
    documents.results.todayDocs.length === 0 &&
    documents.results.thisWeekDocs.length === 0 &&
    documents.results.thisMonthDocs.length === 0 &&
    documents.results.thisYearDocs.length === 0
  )
    return <NoDocumentsFound />;

  return (
    <Stack
      sx={{
        maxWidth: '1100px',
      }}
    >
      <Title />
      <Search />
      {isDesktop && <ToggleFilter />}
      <Paper
        sx={
          isDesktop
            ? {
                p: '24px 16px 88px 16px',
                position: 'relative',
                bgcolor: '#fff',
                borderRadius: '24px',
                border: '1px solid #E7EDFF',
                boxShadow: 'none',
              }
            : {
                p: 0,
                bgcolor: 'transparent',
                border: 'none',
                boxShadow: 'none',
                display: 'flex',
                flexFlow: 'column',
                gap: '20px',
              }
        }
      >
        {isDesktop && (
          <Avatar
            alt=''
            src={PersonWithBoxes}
            sx={{
              position: 'absolute',
              top: '-125px',
              right: '40px',
              width: '173px',
              height: '123px',
            }}
          />
        )}
        {isDesktop ? (
          <Stack direction='row' justifyContent='space-between' mb='16px'>
            <AdvancedFilter />
            <DocumentAmount />
          </Stack>
        ) : (
          <MobileFilter />
        )}
        <AllDocuments />
      </Paper>
    </Stack>
  );
};
